import React from 'react';

export const LazyImage = ({ url, alt, width = '120px', height = '110px' }) => (
  <img
    loading="lazy"
    src={url}
    alt={alt}
    style={{ width, maxHeight: height }}
  />
);
